/**
 * Product info stack: only one accordion row open at a time within .pdp-info-stack__accordions.
 * Uses the details "toggle" event so it works with accordion-disclosure (CustomDetails) animations.
 */
(function () {
  if (window.__pdpInfoStackExclusiveAccordionsInit) return;
  window.__pdpInfoStackExclusiveAccordionsInit = true;

  document.addEventListener(
    'toggle',
    function (event) {
      var details = event.target;
      if (!details || details.tagName !== 'DETAILS') return;
      if (!details.classList.contains('accordion__disclosure')) return;
      var container = details.closest('.pdp-info-stack__accordions');
      if (!container) return;
      if (!details.open) return;

      container.querySelectorAll('accordion-disclosure').forEach(function (acc) {
        var d = acc.querySelector('details');
        if (d && d !== details && d.open && typeof acc.close === 'function') {
          acc.close();
        }
      });
    },
    true
  );
})();
